import React, { PureComponent } from "react";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableBody from "@material-ui/core/TableBody";

//service
import shotService from "../../../../services/shotService";
//components
import SelectShotConfirmRow from "./SelectShotConfirmRow";

export default class SelectShotConfirmTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedRow: null,
      selectedMenu: null,
      shots: [],
      fetching: false,
      failed: false,
      selectedRow: null,
      selectedMenu: null,
      selected: [],
      orderBy: "priority",
      order: "asc",
      filterstate: ""
    };

    this.handleSelectRow = this.handleSelectRow.bind(this);
    this.handleMenu = this.handleMenu.bind(this);
    this.handleCloseMenu = this.handleCloseMenu.bind(this);
  }

  componentDidMount() {
    // this.getShots();
  }

  handleSelectRow(selectedRow) {
    selectedRow === this.state.selectedRow ? this.setState({ selectedRow: null, selectedMenu: null }) : this.setState({ selectedRow });
  }

  handleMenu(e) {
    this.setState({ selectedMenu: e.currentTarget });
  }

  handleCloseMenu() {
    this.setState({ selectedMenu: null });
  }

  deleteShot = async (id, type) => {
    try {
      let { data } = await shotService.deleteOneShot(id);
      console.log(data);
      if (data.statusCode === 200) {
        this.getShots(type);
      }
    } catch (error) {
      console.log("failed to delete shot: ", error);
    }
  };

  createSortHandler = property => {
    console.log("sort", property);
    this.handleRequestSort(property);
  };
  handleRequestSort = property => {
    const isDesc = this.state.orderBy === property && this.state.order === "desc";
    this.setState({ order: isDesc ? "asc" : "desc" });
    this.setState({ orderBy: property });
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc" ? (a, b) => this.desc(a, b, orderBy) : (a, b) => -this.desc(a, b, orderBy);
  };

  desc = (a, b, orderBy) => {
    if (typeof a[orderBy] === "boolean") {
      if (a[orderBy] === b[orderBy]) {
        return b.scene === a.scene ? 0 : b.scene < a.scene ? -1 : 1;
      }
      return a[orderBy] ? 1 : -1;
    } else {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    }
  };

  render() {
    const { orderBy, order, data, filterstate } = this.state;
    let photoLists = this.stableSort(this.props.shots, this.getSorting(order, orderBy)).map(item => {
      const open = Boolean(this.state.selectedMenu) && this.state.selectedRow === item.id ? true : false;
      const selectedRow = this.state.selectedRow === item.id ? true : false;
      const menuAnchorEl = this.state.selectedRow === item.id ? this.state.selectedMenu : null;
      return (
        <SelectShotConfirmRow
          hasCheckbox={this.props.hasCheckbox}
          key={item.id}
          {...item}
          selected={selectedRow}
          handleSelectRow={this.handleSelectRow}
          handleMenu={this.handleMenu}
          handleCloseMenu={this.handleCloseMenu}
          selectedMenu={menuAnchorEl}
          menuSelected={open}
        />
      );
    });
    const headCells = [
      { id: "priority", numeric: false, disablePadding: false, label: "Priority", width: "10%" },
      { id: "scene", numeric: false, disablePadding: false, label: "Scene", width: "15%" },
      { id: "description", numeric: false, disablePadding: false, label: "Description", width: this.props.type === "photo" ? "30%" : "15%" },
      { id: "location", numeric: false, disablePadding: false, label: "Location", width: "15%" },
      { id: "angle", numeric: false, disablePadding: false, label: "Angle", width: "15%" },
      { id: "framing", numeric: false, disablePadding: false, label: "Framing", width: "15%" }
    ];

    if (this.props.type == "video") {
      headCells.push({ id: "camera", numeric: false, disablePadding: false, label: "Camera", width: "15%" });
    }
    return (
      <Grid container>
        <Grid item xs={12} sm={12}>
          {this.state.fetching ? (
            <div style={{ textAlign: "center" }}>
              <LinearProgress color="primary" style={{ height: 2 }} />
            </div>
          ) : this.state.failed ? (
            <div>
              <h1>Failed to load. Please try again later.</h1>
              <Button size="small" variant="contained" color="secondary" onClick={this.getShots} style={{ marginLeft: 20 }}>
                Reload
              </Button>
            </div>
          ) : null}
          <Table style={{ tableLayout: "fixed" }}>
            <TableHead>
              <TableRow>
                {headCells.map((row, key) => (
                  <TableCell
                    key={key}
                    align={row.numeric ? "right" : "left"}
                    padding={row.disablePadding ? "none" : "default"}
                    sortDirection={orderBy === row.id ? order : false}
                    onClick={row.id == "" ? null : () => this.createSortHandler(row.id)}
                    style={row.id == "" ? { width: row.width } : { cursor: "pointer", width: row.width }}
                  >
                    {this.state.orderBy === row.id ? (
                      <TableSortLabel active={orderBy === row.id} direction={order}>
                        {row.label}
                      </TableSortLabel>
                    ) : (
                      row.label
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>{photoLists}</TableBody>
          </Table>
        </Grid>
      </Grid>
    );
  }
}
